import { Link, UIText2 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './Contacts.css';
import { IAgentCard } from '../../types/agentCard';
import { AsideRow } from '../AsideRow';

interface IContactsProps {
  phonesNode: React.ReactNode | null;
  regionsNames: string;
  skype: IAgentCard['skype'];
  email?: string | null;
  website: IAgentCard['website'];
}

export const Contacts = ({ phonesNode, skype, email, website, regionsNames }: IContactsProps) => {
  if (!phonesNode && !website && !skype && !email && !regionsNames) {
    return null;
  }

  return (
    <div data-name="Contacts" className={styles['container']}>
      {phonesNode && (
        <AsideRow title="Телефон:" content={<div className={styles['phone-container']}>{phonesNode}</div>} />
      )}
      {website && <AsideRow title="Сайт:" content={<UIText2 color="primary_100">{website}</UIText2>} />}
      {skype && (
        <AsideRow
          title="Skype:"
          content={
            <Link fontSize="S" href={`skype:${skype}`}>
              {skype}
            </Link>
          }
        />
      )}
      {email && (
        <AsideRow
          title="Email:"
          content={
            <Link fontSize="S" href={`mailto:${email}`}>
              {email}
            </Link>
          }
        />
      )}
      {regionsNames && <AsideRow title="Регион работы:" content={<UIText2>{regionsNames}</UIText2>} />}
    </div>
  );
};
